import RegulationPanelRow from './RegulationPanelRow';

export { RegulationPanelRow };
export default RegulationPanelRow;
